export enum NotificationMessageType {
  MissionStart = 0,
  MissionPause = 1,
  MissionCompleted = 2,
  MissionCancelled = 3,
  NewField = 4,
  NewPath = 5,
  ModifiedField = 6,
  ModifiedPath = 7
}
